<ng-container *ngIf="enableTopFour && shouldShowTopContent">
  <ng-container *ngIf="collectionData?.contentTop">
    <eds-card-promo
      edsPadding
      edsPaddingBottom="lg"
      eventId="linkOrButtonClick"
      [contentTop]="collectionData?.contentTop"
      [showDivider]="false"
    >
    </eds-card-promo>
  </ng-container>
</ng-container>

<div *ngIf="!enableCollections && promoContent" edsSpacing="lg">
  <eds-title
    *ngIf="promoContent?.title"
    [title]="promoContent?.title"
    size="h3"
    edsSpacing="xs"
  ></eds-title>
  <div
    *ngIf="promoContent?.htmlBlock"
    [innerHtml]="promoContent?.htmlBlock?.html"
  ></div>
  <eds-video
    *ngIf="promoContent?.embeddedVideo"
    [embedScript]="promoContent?.embeddedVideo?.videoEmbedCode"
  >
  </eds-video>
</div>

<ng-container *ngIf="enableTopFour && collectionData">
  <ng-container *ngIf="collectionData.contentBottom">
    <eds-card-promo
      edsPadding
      edsPaddingBottom="lg"
      [contentBottom]="collectionData?.contentBottom"
      eventId="linkOrButtonClick"
      [targetedLinkItems]="targetedLink"
      [isTargetedLink]="true"
    >
    </eds-card-promo>
  </ng-container>
</ng-container>

<div
  edsPadding
  *ngIf="this.enableCollections && collections.length > 0"
  [edsPaddingTop]="enableTopFour ? 'xxl' : ''"
>
  <eds-sidebar
    [label]="translationLabel?.articlesCollection"
    [hasShadows]="false"
    [hasBorders]="false"
    [hasPadding]="false"
  >
    <eds-divider edsSpacing="sm"></eds-divider>
    <ng-container *ngFor="let article of collections; let i = index">
      <ng-container *ngIf="article.theme?.length > 0">
        <ng-container *ngIf="article.category">
          <div>
            <a
              [ngClass]="article.external ? 'external-link' : ''"
              [title]="article.category"
              [attr.data-signin-required]="article.signInRequired"
              class="sidebar__list-item sidebar__list-item--grey1"
              edsFlexbox
              alignItems="center"
              justifyContent="space-between"
              edsPadding
              edsPaddingBottom="sm"
              (click)="toggleExpanded(i)"
            >
              <div edsPadding edsPaddingRight="xs">
                <p class="bold spacing--none">
                  {{ article.category }}
                </p>
              </div>

              <eds-icon
                class="sidebar__icon--primary"
                [type]="!expand[i] ? 'carrot-down' : 'carrot-up'"
                size="small"
              ></eds-icon>
            </a>
            <div *ngIf="expand[i]" edsSpacing="sm">
              <ng-container *ngFor="let themeCollection of article.theme">
                <eds-link-item
                  edsSpacing="xs"
                  edsPadding
                  edsPaddingLeft="xs"
                  *ngIf="themeCollection.isTargeteAvailable"
                  class="inline-item"
                  [title]="themeCollection.displayText"
                  [href]="themeCollection.url"
                  [isNewWindow]="themeCollection.target"
                >
                </eds-link-item>
              </ng-container>
            </div>
            <eds-divider
              *ngIf="i < collectionData?.collection?.length - 1"
              edsPadding
              edsPaddingBottom="sm"
            ></eds-divider>
          </div>
        </ng-container>
        <ng-container *ngIf="!article.category">
          <ng-container *ngFor="let themeCollection of article.theme">
            <eds-link-item
              edsSpacing="xs"
              *ngIf="themeCollection.isTargeteAvailable"
              class="inline-item"
              [title]="themeCollection.displayText"
              [href]="themeCollection.url"
              [isNewWindow]="themeCollection.target"
            >
            </eds-link-item>
          </ng-container>
          <eds-divider
            *ngIf="article?.hasValidLink"
            edsPadding
            edsPaddingBottom="sm"
          ></eds-divider>
        </ng-container>
      </ng-container>
    </ng-container>
  </eds-sidebar>
</div>

<div
  edsPadding
  *ngIf="this.enableCollections && collection.length > 0"
  [edsPaddingTop]="enableTopFour ? 'xxl' : ''"
>
  <eds-sidebar
    [label]="translationLabel?.articlesCollection"
    [hasShadows]="false"
    [hasBorders]="false"
    [hasPadding]="false"
  >
    <div *ngFor="let article of collection; let i = index">
      <a
        [href]="article.url"
        [target]="article.target"
        [ngClass]="article.external ? 'external-link' : ''"
        [title]="article.title"
        [attr.data-signin-required]="article.signInRequired"
        class="sidebar__list-item sidebar__list-item--grey1"
        edsFlexbox
        alignItems="center"
        justifyContent="space-between"
        edsPadding
        edsPaddingBottom="sm"
      >
        <div edsPadding edsPaddingRight="xs">
          <p class="bold spacing--none">
            {{ article.displayText }}
          </p>
        </div>

        <eds-icon
          class="sidebar__icon--primary"
          type="carrot-right"
          size="small"
        ></eds-icon>
      </a>
      <eds-divider
        *ngIf="i < collectionData?.collections?.length - 1"
        edsPadding
        edsPaddingBottom="sm"
      ></eds-divider>
    </div>
  </eds-sidebar>
</div>
